import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Alert, Box, Button, Stack, TextField, Typography } from '@mui/material';

import ChampMotDePasse from '../../../components/Auth/ChampMotDePasse';
import EcranAuth from '../../../components/Auth/EcranAuth';
import { useAuth } from '../../../context/AuthContext';

function Login() {
  const { login } = useAuth();
  const naviguer = useNavigate();
  const [parametres] = useSearchParams();
  // On arrive ici parce que la session a expiré en cours de travail : le dire,
  // et ramener ensuite là où l'on était.
  const expire = parametres.get('expire') === '1';
  // `suite` vient de l'URL : on n'en accepte qu'un chemin interne. « // » en
  // tête désignerait un autre domaine, et renverrait l'utilisateur ailleurs
  // juste après qu'il a saisi son mot de passe.
  const demande = parametres.get('suite') || '';
  const suite = demande.startsWith('/') && !demande.startsWith('//')
    ? demande : null;

  const [email, setEmail] = useState('');
  const [motDePasse, setMotDePasse] = useState('');
  const [erreur, setErreur] = useState('');
  const [occupe, setOccupe] = useState(false);

  const soumettre = async (e) => {
    e.preventDefault();
    setOccupe(true);
    setErreur('');
    try {
      await login({ username: email.trim(), password: motDePasse });
      // `RoleRedirect` décide de la page d'accueil selon le rôle : on ne la
      // devine pas ici, sauf si l'on sait d'où l'on vient.
      naviguer(suite || '/');
    } catch (error) {
      setErreur(error.response?.status === 401
        ? 'Email ou mot de passe incorrect.'
        : "La connexion n'a pas abouti. Réessayez dans un instant.");
      setOccupe(false);
    }
  };

  return (
    <EcranAuth
      titre="Connexion"
      sous_titre="Accédez à votre espace"
      bas={(
        <Typography variant="body2" color="text.secondary">
          Pas encore de compte ?{' '}
          <Box component={Link} to="/signup"
               sx={{ color: 'primary.main', fontWeight: 600 }}>
            Créer un compte
          </Box>
        </Typography>
      )}
    >
      <Box component="form" onSubmit={soumettre} noValidate>
        {expire && !erreur && (
          <Alert severity="info" sx={{ mb: 3 }}>
            Votre session a expiré. Reconnectez-vous : vous reviendrez où vous
            étiez.
          </Alert>
        )}
        {erreur && <Alert severity="error" sx={{ mb: 3 }}>{erreur}</Alert>}

        <Stack spacing={2.5}>
          <TextField
            label="Adresse email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="username"
            autoFocus
            required
          />

          <ChampMotDePasse
            value={motDePasse}
            onChange={(e) => setMotDePasse(e.target.value)}
            autoComplete="current-password"
            required
            fullWidth
          />

          <Box sx={{ textAlign: 'right', mt: -1 }}>
            <Typography component={Link} to="/mot-de-passe-oublie"
                        variant="body2" sx={{ color: 'primary.main' }}>
              Mot de passe oublié ?
            </Typography>
          </Box>

          <Button type="submit" variant="contained" size="large"
                  disabled={occupe}>
            {occupe ? 'Connexion…' : 'Se connecter'}
          </Button>
        </Stack>
      </Box>
    </EcranAuth>
  );
}

export default Login;
